import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-component',
  templateUrl: './loading-component.component.html',
  styleUrls: ['./loading-component.component.css']
})
export class LoadingComponentComponent implements OnInit {

  i:number = 0;
  width:number = 1;
  constructor() { }

  ngOnInit() {
     // this.move();
  }



   move() {
    if (this.i == 0) {
      this.i = 1;
      var elem = document.getElementById("myBar");
      var width = 1;
      var id = setInterval(function () {
        if (width >= 100) {
          this.i = 0;
          width = 0;

        } else {
          width++;
          elem.style.width = width + "%";
        }
      }, 30);
    }
  }

}
